import {
	type AsyncIntlProviderComponent,
	createAsyncIntlProvider,
} from '@atlaskit/intl-messages-provider/async';

import messages from '../../../i18n/en';
import { asyncLanguages } from './async-languages';

/** Provides GlobalRoot's messages unless the consumer supplies them through its own intl context. */
export const AsyncIntlProvider: AsyncIntlProviderComponent = createAsyncIntlProvider({
	defaultMessages: messages,
	asyncLanguages,
});
